// src/components/JobList.js
import React, { useState } from "react";
import { API_BASE_URL } from "../config";
import JobCard from "./JobCard";
import JobDetailsModal from "./JobDetailsModal";
import { useNavigate } from "react-router-dom";
import ApplyModal from "./ApplyModal";
import SubmissionSuccessModal from "./SubmissionSuccessModal";



const JobList = ({ jobs, onStartChatbot }) => {
  const navigate = useNavigate();
  const [selectedJob, setSelectedJob] = useState(null);
  const [showApplyModal, setShowApplyModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [candidateId, setCandidateId] = useState(""); // Track candidate ID for interview session
  const [candidateName, setCandidateName] = useState(""); // Track candidate name for use in success modal
  const [highScore, setHighScore] = useState(false); // Track score status for success modal

  const sendApplyNotification = (jobRole) => {
    fetch(`${API_BASE_URL}/api/candidate_apply_notification`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ job_role: jobRole })
    })
      .then(response => response.json())
      .then(data => console.log('Notification sent:', data))
      .catch(error => console.error('Error:', error));
  };

  const handleApply = (job) => {
    sendApplyNotification(job.jobrole);
    const jobNameSlug = job.jobrole.toLowerCase().replace(/\s+/g, "-");
    const jobSlug = `${jobNameSlug}-${job.jobid}`;
    navigate(`/apply/${jobSlug}`);
  };

  const handleView = (job) => {
    setSelectedJob(job);
    setShowApplyModal(false);
    setShowSuccessModal(false);
    setCandidateName("");
    setHighScore(false);
  };

  // Updated to accept name, job, and score parameters
  const handleSuccess = (name, job, score, candidateId) => {
    setCandidateId(candidateId);
    setCandidateName(name);
    setSelectedJob(job);
    setHighScore(score >= 40);
    setShowSuccessModal(true);
    setShowApplyModal(false);
  };

  const handleClose = () => {
    setSelectedJob(null);
    setShowApplyModal(false);
    setShowSuccessModal(false);
    setCandidateName("");
    setHighScore(false);
  };

  const handleCloseModal = () => {
    // Close modal, go back to main screen (do not open chatbot)
    setShowSuccessModal(false);
    setSelectedJob(null);
    setCandidateName("");
    setHighScore(false);
  };

  const handleContinueToInterview = () => {
    // Close modal, open chatbot interview UI
    if (onStartChatbot && selectedJob) {
      onStartChatbot(candidateName, selectedJob, candidateId);
    }
    setShowSuccessModal(false);
  };

  const handleContinue = () => {
    console.log("handleContinue called with candidate:", candidateName, "job:", selectedJob);
    if (onStartChatbot && selectedJob) {
      onStartChatbot(candidateName, selectedJob);
    }
    handleClose();
  };

  return (
    <>
      <section>
        <h2 className="jobs-heading">Available Positions</h2>
        <p className="jobs-subheading">Discover exciting career opportunities at leading tech companies</p>
        <div className="jobs-grid">
          {jobs.map((job) => (
            <JobCard
              key={job.jobid}
              job={job}
              onViewDetails={() => handleView(job)}
              onApplyClick={() => handleApply(job)}
            />
          ))}
        </div>
      </section>

      {/* Job Details modal */}
      {selectedJob && !showApplyModal && !showSuccessModal && (
        <JobDetailsModal
          job={selectedJob}
          onClose={handleClose}
          onApply={() => {
            sendApplyNotification(selectedJob.jobrole);
            setShowApplyModal(true);
          }}
        />
      )}

      {/* Apply modal */}
      {showApplyModal && selectedJob && (
        <ApplyModal
          job={selectedJob}
          onClose={handleClose}
          onSuccess={handleSuccess} // Pass full callback here to capture name, job, score
        />
      )}

      {/* Success modal */}
      {showSuccessModal && (
        <SubmissionSuccessModal
          candidateName={candidateName}
          job={selectedJob}
          highScore={highScore}
          onClose={handleCloseModal}       // Close button only closes modal
          onContinue={handleContinueToInterview} // Continue button opens chat
        />
      )}
    </>
  );
};

export default JobList;
